var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("content-item", {
        attrs: { "item-key": _vm.errorContent, "bundle-name": "Authentication" }
      }),
      _vm._v(" "),
      _vm.errorMessage
        ? _c(
            "b-alert",
            { attrs: { show: "", variant: "warning" } },
            [
              _c("b-icon-exclamation-triangle", { staticClass: "mr-3" }),
              _vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n    ")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "border rounded",
          staticStyle: { width: "373px", padding: "24px" }
        },
        [
          _c("h2", { staticStyle: { color: "#106282" } }, [
            _vm._v("\n            Link an Existing Profile\n        ")
          ]),
          _vm._v(" "),
          _c(
            "b-form",
            {
              staticClass: "d-flex flex-column",
              staticStyle: { gap: "24px" },
              on: { submit: _vm.signIn }
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column",
                  staticStyle: { gap: "16px" }
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("label", { attrs: { for: "username" } }, [
                            _vm._v("Username")
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "/site/vaccn/main/public/account-reset?feature=forgot-password"
                              }
                            },
                            [_vm._v("Forgot Username?")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: { id: "username" },
                        model: {
                          value: _vm.userName,
                          callback: function($$v) {
                            _vm.userName = $$v
                          },
                          expression: "userName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("label", { attrs: { for: "password" } }, [
                            _vm._v("Password")
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "/site/vaccn/main/public/account-reset?feature=forgot-password"
                              }
                            },
                            [_vm._v("Forgot Password?")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: { id: "password", type: "password" },
                        model: {
                          value: _vm.password,
                          callback: function($$v) {
                            _vm.password = $$v
                          },
                          expression: "password"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "text-center" }, [
                _vm._v("\n                Don't have an account? "),
                _c(
                  "a",
                  { attrs: { href: "/site/vaccn/main/public/registration" } },
                  [_vm._v("Register now.")]
                )
              ]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "align-self-end py-3 px-4",
                  staticStyle: { width: "fit-content" },
                  attrs: { type: "submit", variant: "primary" }
                },
                [_vm._v("Link Profile")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal.privacy-modal",
                  modifiers: { "privacy-modal": true }
                }
              ],
              attrs: { href: "javascript:void(0)" }
            },
            [_vm._v("Privacy")]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            { attrs: { id: "privacy-modal", "ok-only": "" } },
            [
              _c("h3", [_vm._v("Privacy & Legal Information")]),
              _vm._v(" "),
              _c("content-item", {
                attrs: {
                  "item-key": "PRIVACY_NOTICE",
                  "bundle-name": "Authentication"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "new-password-modal",
            title: "Reset Password",
            "ok-title": "Reset & Sign In",
            size: "lg"
          },
          on: { ok: _vm.signIn }
        },
        [
          _c("content-item", {
            attrs: {
              "item-key": _vm.newPasswordMessage,
              "bundle-name": "Authentication"
            }
          }),
          _vm._v(" "),
          _c(
            "b-container",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                "justify-content": "space-between"
              }
            },
            [
              _c(
                "b-form",
                {
                  staticClass: "d-flex flex-column",
                  staticStyle: { gap: "24px", width: "30%" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column",
                      staticStyle: { gap: "16px" }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-between" },
                            [
                              _c("label", { attrs: { for: "newPassword" } }, [
                                _vm._v("New Password "),
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*")
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { id: "newPassword", type: "password" },
                            model: {
                              value: _vm.newPassword,
                              callback: function($$v) {
                                _vm.newPassword = $$v
                              },
                              expression: "newPassword"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-between" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "newPasswordConfirmation" } },
                                [
                                  _vm._v(
                                    "\n                                Confirm Password "
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              id: "newPasswordConfirmation",
                              type: "password"
                            },
                            model: {
                              value: _vm.newPasswordConfirmation,
                              callback: function($$v) {
                                _vm.newPasswordConfirmation = $$v
                              },
                              expression: "newPasswordConfirmation"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "max-width": "65%" } },
                [
                  _c("content-item", {
                    attrs: {
                      "item-key": "AUTHENTICATION_RACF_ACCOUNT_RESET_RIGHT",
                      "bundle-name": "Authentication"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56785150", { render: render, staticRenderFns: staticRenderFns })
  }
}